// @ vendor
const React = require('react');
const classnames = require('classnames');

// @ utilities
const { toFirstUppercase } = require('utilities/stringHelper');
const { formatText } = require('core/i18n').i18n;
const { getFormattedString } = require('utilities/currencyHelper');

// @ constant
const { THIRD_STEP, FOURTH_STEP } = require('constants/index');
const { PAYMENT_TYPE, text } = require('../../insuranceConstants/insuranceRequestHome');
const { EURO_TEXT } = require('constants/index');

const formatCurrency = (amount, decimalsLength = 0) => {
    return getFormattedString({
        amount: amount,
        currency: EURO_TEXT,
        decimalsLength
    });
}

const insuranceRequestBuildPaymentTypeItem = (
    immInsuranceState,
    immInsuranceWizardState,
    hasSimulation,
    hasSimulationChanged,
    dropDown = false,
    isRnc = false
) => {
    const stepToGetData = isRnc ? THIRD_STEP : FOURTH_STEP;
    const stepData = immInsuranceWizardState.getIn(['steps', stepToGetData]);
    const plan = isRnc ? stepData.get('insurancePlan') : immInsuranceState.getIn(['data', 'insurancePlan']) || '';
    const paymentType = stepData.get('paymentType') || '';
    const isPaymentTypeDifferentToAnnual = paymentType !== PAYMENT_TYPE.ANNUAL;
    const pricing = stepData.getIn(['pricing', paymentType.toLowerCase(), plan.toLowerCase()]);
    let paymentTypeText = formatText('insuranceRequestHome-summaryToBeDefined');
    const validationIfIsRnc = isRnc
        ? paymentType && !hasSimulationChanged && plan
        : paymentType && hasSimulation && !hasSimulationChanged;

    const disabledTextIfRnc = isRnc
        ? !plan || hasSimulationChanged
        : !hasSimulation || hasSimulationChanged

    if (validationIfIsRnc) {
        let pricingText;
        if (isPaymentTypeDifferentToAnnual && pricing) {

            pricingText = (
                <span className="insurance-request-compilation-card__text-complementary">
                    {text().SUMMARY.FIRST_IMPORT[paymentType]}
                    <span className="insurance-request-compilation-card__text-complementary--important">
                        {formatCurrency(pricing.get('firstImport'), 2)}
                    </span>
                    <br />
                    {text().SUMMARY.SUCCESSIVE_IMPORT[paymentType]}
                    <span className="insurance-request-compilation-card__text-complementary--important">
                        {formatCurrency(pricing.get('succesiveReceiptsImport'), 2)}
                    </span>
                </span>
            );
        }

        if (dropDown) {
            paymentTypeText = (
                <span>
                    {formatText(`insuranceRequestHome-step4paymentType${toFirstUppercase(paymentType)}`)}
                </span>
            );
            return {
                label: formatText('insuranceRequestHome-summaryPaymentType'),
                text: paymentTypeText,
                className: classnames({
                    'insurance-request-compilation-card__text--disabled': disabledTextIfRnc
                }),
                flag: isPaymentTypeDifferentToAnnual ? 'paymentTypeWithDropdown' : '',
                paymentType,
                pricing,
                isPaymentTypeDifferentToAnnual,
            };
        }
        paymentTypeText = (
            <span>
                {formatText(`insuranceRequestHome-step4paymentType${toFirstUppercase(paymentType)}`)}
                {pricingText}
            </span>
        );

    }
    return {
        label: formatText('insuranceRequestHome-summaryPaymentType'),
        text: paymentTypeText,
        className: classnames({
            'insurance-request-compilation-card__text--disabled': disabledTextIfRnc
        }),
    };

}

module.exports = insuranceRequestBuildPaymentTypeItem;
